export default "__VITE_PUBLIC_ASSET__d0251089__"